// ST-1705 -Claude- Sends SPA route changes to analytics providers.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './googleTag';

export function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [location.hash, location.pathname, location.search]);

  return null;
}
